import { SETTING_BASE_ROUTE } from 'App/constants/settingsRoute';

export const infoMessageRoutes = {
  infoMessage: `${SETTING_BASE_ROUTE}/info-message`,
};
